import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { PartnerHospitalRepository } from './domain/PartnerHospitalRepository'

import { PartnerHospitalView, PartnerLegacyHospital } from '../../contracts/hospital'
import { AxiosErrorHandler, SolarResponse } from '../../foundation'

export class PartnerApiHospital implements PartnerHospitalRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getHospital = async (): Promise<PartnerHospitalView> => {
    const config: AxiosRequestConfig = {
      url: '/hospital/partner/queries/get-hospital/process',
      method: 'post',
    }

    try {
      const { data } = await this.axios.request<PartnerHospitalView>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getLegacyHospital = async (): Promise<PartnerLegacyHospital> => {
    const config: AxiosRequestConfig = {
      url: '/partner/v3/hospitals/me',
      method: 'get',
    }

    const { data } = await this.axios.request<SolarResponse<PartnerLegacyHospital>>(config)
    return data.data
  }
}
